import { useQuery } from "@tanstack/react-query";
import { fetchSiteSettings } from "../api/public.api.js";

/**
 * Reads the public site-settings document and returns the page-visibility
 * flags. Defaults to "everything visible" while the query is loading or if
 * the request fails — that's the safer fallback when the network is flaky:
 * better to show too much than to silently hide working pages.
 *
 * Used by Header, Footer, and the route guards on /display-homes and
 * /house-land. Cached for a short window so admin changes show up
 * within ~30 s on the public site without a hard reload.
 */
const FALLBACK = Object.freeze({
  displayHomes: true,
  houseLand: true,
});

export function usePageVisibility() {
  const { data } = useQuery({
    queryKey: ["public", "settings", "visibility"],
    queryFn: fetchSiteSettings,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
  const v = data?.pageVisibility;
  return {
    displayHomes: v?.displayHomes ?? FALLBACK.displayHomes,
    houseLand: v?.houseLand ?? FALLBACK.houseLand,
  };
}
